import React, {
  useState,
  useContext,
  useCallback,
} from 'react';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import ClaimLeadButton from '../../components/Leads/components/ClaimLeadButton';
import LeadsModal from '../../components/Leads/components/v2/LeadModal';
import CoachesListContext from '../../context/CoachesListContext';
import UserContext from '../../../context/UserContext';

import AgentProfileSection from './components/AgentProfileSection';
import LeadsTableSection from './components/LeadsTableSection';
import AgentStatsSection from './components/AgentStatsSection';
import {
  Container,
  HeaderRow,
} from './styles';

const ISDashboard = () => {
  const [requireOutcome, setRequireOutcome] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showContractModal, setShowContractModal] = useState(false);

  const {
    userDoc: { id: userId, name: userName },
  } = useContext(UserContext);
  const { coachesList, isReady } = useContext(CoachesListContext);

  const handleLeadModalClose = useCallback(() => {
    setRequireOutcome(false);
    setShowContractModal(false);
  }, []);

  const onLeadClaim = useCallback((lead) => {
    setRequireOutcome(true);
    setSelectedLead(lead);
    setShowContractModal(true);
  }, []);

  return (
    <Container>
      <HeaderRow>
        <AgentProfileSection />
        <ClaimLeadButton onLeadClaim={onLeadClaim} />
      </HeaderRow>
      <AgentStatsSection isCoachesListReady={isReady} coachesList={coachesList} />
      <LeadsTableSection
        setShowQuestionsModal={setShowContractModal}
        coachesList={coachesList}
        selectedLead={selectedLead}
        setSelectedLead={setSelectedLead}
      />
      {(selectedLead && showContractModal) && (
        <LeadsModal
          lead={selectedLead}
          showModal={showContractModal}
          onClose={handleLeadModalClose}
          userId={userId}
          userName={userName}
          isInsideSalesView
          requireOutcome={requireOutcome}
        />
      )}
    </Container>
  );
};

export default compose(
  observer,
)(ISDashboard);
